import { render, staticRenderFns } from "./Scraping.vue?vue&type=template&id=1bf91b6e&scoped=true"
import script from "./Scraping.vue?vue&type=script&lang=js"
export * from "./Scraping.vue?vue&type=script&lang=js"
import style0 from "./Scraping.vue?vue&type=style&index=0&id=1bf91b6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf91b6e",
  null
  
)

export default component.exports